<template>
  <div>
    <div class="shadow-card">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <a-button
          :style="{ color: getPrimaryColor(), border: '1px solid ' + getPrimaryColor(), color: 'white !important' }"
          class="py-1 pl-3 pr-4 left-radius right-radius d-flex align-items-center"
          @click="$router.push({ name: 'ResourceList' })"
        >
          <h4 :style="{ color: getPrimaryColor() }" class="mb-0 mr-3"></h4>
          <h6 :style="{ color: getPrimaryColor() }" class="mb-0">Back to Resources123</h6>
        </a-button>
        <h6>Last Updated: {{ video.last_updated | updatedAt }}</h6>
      </div>
      <h3>{{ video.article_title }}</h3>
      <p>
        <iframe
          width="100%"
          height="400px"
          :src="`https://www.youtube.com/embed/${video.ext_ref_id}`"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </p>
      <p><span v-html="video.article_description"></span></p>
      <!-- <hr>
      <div style="display:flex;justify-content:space-between;">
        <a
          id="hugs" class="u-options"
          @click="react(video, $event)"
        >
          <i
            class="fa fa-smile-o"
            aria-hidden="true"
            :class="reactions.hugs ? 'hugged' : ''"
          ></i> <div>  Hug ({{ video.reaction.hugs }}) </div>
        </a>
        <a
          id="likes" class="u-options"
          @click="react(video, $event)"
        >
          <i
            class="fa fa-heart-o"
            aria-hidden="true"
            :class="reactions.likes ? 'liked' : ''"
          ></i> <div> Like ({{ video.reaction.likes }}) </div>
        </a>
        <a class="u-options" @click="comments.length === 0 && fetchComments()">
          <i
            class="fa fa-sticky-note-o"
            aria-hidden="true"
          ></i><div>  Comment </div>
        </a>
        <a
          id="favorites" class="u-options"
          @click="react(video, $event)"
        >
          <i
            class="fa fa-bookmark"
            aria-hidden="true"
            :class="reactions.favorites ? 'fav' : ''"
          ></i><div>  Bookmark </div>
        </a>
        <a class="u-options" @click="() => $refs.sharePostModal.show(video, 4, 'Share Video')">
          <i
            class="fa fa-share-alt"
            aria-hidden="true"
          ></i><div>  Share </div>
        </a>
      </div>
      <hr>
      <div style="display:flex;justify-content:space-between;">
          <div class="title">
            <img :src="authUser.user.thumbnail_url" alt="" class="post-comment-image">
          </div>
          <a-input placeholder="Comment on article..." v-model="comment"/>
          <a-button
            :loading="commenting"
            class='dovemed-button font-white ml-4'
            :style="{'background': getPrimaryColor()}"
            @click="postComment()"
            >Post
          </a-button>
        </div> -->
      <hr />
      <div class="d-flex justify-content-between align-items-center">
        <a class="mr-4 mb-1" @click="() => $refs.sharePostModal.show(video, 8, 'Share Video')" :style="{ color: getPrimaryColor() }">
          <i :style="{ color: getPrimaryColor() }" class="fa fa-share-alt" aria-hidden="true"></i> SHARE
        </a>
        <span>
          WATCH ANOTHER VIDEO<a-button class="pt-1 pb-1 ml-1" shape="circle" :style="{ background: getPrimaryColor() }" @click="$router.push({ name: 'ResourceList' })">
            <i class="fa fa-arrow-right font-white" aria-hidden="true" style="font-size: 16px"></i>
          </a-button>
        </span>
      </div>
    </div>
    <SharePostModal ref="sharePostModal" />
  </div>
</template>

<script>
import SharePostModal from "../../../Modals/SharePost"
import { RepositoryFactory } from "../../../../repositories/RepositoryFactory"
import moment from "moment"

const PostRepository = RepositoryFactory.get("posts")

export default {
  props: {
    videoData: Object,
  },
  name: "Video",
  data() {
    return {
      reactions: {
        hugs: false,
        likes: false,
        favorites: false,
        flag: false,
      },
      video: null,
      comment: null,
      monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      commenting: false,
      posting: false,
    }
  },

  components: {
    SharePostModal,
  },

  created() {
    // this.article = JSON.parse(localStorage.getItem('__at'))
    this.video = this.videoData
    this.reactions.hugs = !!this.getReaction(1).length
    this.reactions.likes = !!this.getReaction(2).length
    this.reactions.favorites = !!this.getReaction(4).length
    this.reactions.flag = !!this.getReaction(5).length
  },

  filters: {
    updatedAt(date) {
      return moment(date).format("DD/MM/YYYY")
    },
  },

  methods: {
    getFullImageUrl(url) {
      return `http://103.67.238.86:8010${url}`
    },

    /**
     * Comment on a article
     *
     */
    postComment() {
      this.commenting = true
      const payload = {
        article_id: this.video.article_id,
        comment_text: this.comment,
        user: this.authUser.user.id,
        commented_on_type: 4,
        commented_on_id: this.video.article_id,
      }
      PostRepository.postComment(payload, this.currentCircle.id)
        .then(res => {
          this.comment = ""
          this.currentPage = 1
          this.commenting = false
          // this.fetchComments()
        })
        .catch(err => {
          this.commenting = false
        })
    },

    /**
     * Fetch article comments
     *
     * @param {Object} post
     */
    fetchArticleComments(append = false) {
      const user = JSON.parse(localStorage.getItem("user"))
      const headers = {
        Authorization: `Bearer ${user.user.token}`,
      }
      this.$http
        .get(`${process.env.BASE_API_URL}/dovemedpostcomments/?page_num=${this.currentPage}&items=${this.limit}&post_id=${this.post.id}`, { headers })
        .then(res => {
          if (append) {
            this.comments.push(...res.data.data.data)
          } else {
            if (res.data) {
              this.comments = res.data.data.data
              this.pagination = res.data.data.paginator
            }
          }
          this.currentPage += 1
          this.showWritable = true
        })
        .catch(err => {})
    },

    /**
     * Get reaction of a given type
     *
     * @param {Integer} type
     */
    getReaction(type) {
      let status = []
      status = this.article.my_reaction.filter(reaction => {
        return reaction.reaction_type === type && reaction.user === this.authUser.user.id
      })
      return status
    },

    /**
     * Reaction to any post/comment. Based on the reaction, send required payload.
     *
     * @param {Object} post
     * @param {Object} event
     */
    react(entity, event, comment = false) {
      const REACTION_TYPES = {
        HUGS: 1,
        LIKE: 2,
        USEFUL: 3,
        FAVORITE: 4,
        FLAGED: 5,
      }

      const REACTION_ON = {
        POST: 1,
        COMMENT: 2,
        QUESTION: 3,
        ARTICLE: 4,
      }
      if (this.posting) {
        return
      }
      let path = event.path || (event.composedPath && event.composedPath())
      const type = event.target.id ? event.target.id : path[1]["id"]

      switch (type) {
        case "hugs":
          this.reactions.hugs ? this.deleteReaction(REACTION_TYPES.HUGS, type) : this.saveReaction(entity.id, REACTION_TYPES.HUGS, comment ? REACTION_ON.COMMENT : REACTION_ON.ARTICLE)
          break
        case "likes":
          this.reactions.likes ? this.deleteReaction(REACTION_TYPES.LIKE, type) : this.saveReaction(entity.id, REACTION_TYPES.LIKE, comment ? REACTION_ON.COMMENT : REACTION_ON.ARTICLE)
          break
        case "favorites":
          this.reactions.favorites ? this.deleteReaction(REACTION_TYPES.FAVORITE, type) : this.saveReaction(entity.id, REACTION_TYPES.FAVORITE, comment ? REACTION_ON.COMMENT : REACTION_ON.ARTICLE)
          break
        case "flag":
          this.reactions.flag ? this.deleteReaction(REACTION_TYPES.FLAGED, type) : this.saveReaction(entity.id, REACTION_TYPES.FLAGED, comment ? REACTION_ON.COMMENT : REACTION_ON.ARTICLE)
          break
        default:
          break
      }
    },

    /**
     * Delete reaction to post
     *
     * @param {Integer} reactionId
     */
    deleteReaction(reactionId, type) {
      const reactions = this.getReaction(reactionId)

      let ids = ""
      ids = reactions.map(reaction => {
        return reaction.id
      })
      this.posting = true
      // const currentCircle = JSON.parse(localStorage.getItem('currentCircle'))
      const headers = {
        Authorization: `Bearer ${this.authUser.user.token}`,
      }
      this.reactions[type] = false
      this.$http
        .delete(`${process.env.BASE_API_URL}/reactions/?ids=${ids.toString()}`, { headers })
        .then(res => {
          this.posting = false
          this.reactions[type] = false
          if (this.article.reaction[type] > 0) {
            this.article.reaction[type] -= 1
          }
        })
        .catch(err => {
          this.posting = false
        })
    },

    /**
     * Save reaction to post
     *
     * @param {Integer} postId
     * @param {Integer} reactionType
     * @param {Integer} reactionOnType
     */
    saveReaction(postId, reactionType, reactionOnType) {
      const MIRROR_REACTION_TYPES = {
        1: "hugs",
        2: "likes",
        4: "favorites",
      }
      const payload = {
        reacted_on_type: reactionOnType,
        reacted_on_id: postId,
        user: this.authUser.user.id,
        reaction_type: reactionType,
      }

      this.posting = true
      this.reactions[MIRROR_REACTION_TYPES[reactionType]] = true
      PostRepository.saveReaction(this.currentCircle.id, payload)
        .then(res => {
          // this.reactions[MIRROR_REACTION_TYPES[reactionType]] = true
          this.posting = false
          this.article.reaction[MIRROR_REACTION_TYPES[reactionType]] += 1
          const index = this.article.my_reaction.findIndex(rs => rs.reaction_type === reactionType)
          if (index >= 0) {
            this.article.my_reaction.splice(index, 1)
          }
          this.article.my_reaction.push(res.data.data)
        })
        .catch(err => {
          this.posting = false
        })
    },
  },
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/home/resources/contents/Video.vue